<template>
  <div class="header-container">
    <router-link to="/materials"
      ><img src="@/assets/img/logo.svg" :class="{ invert: isDark }" alt="logo"
    /></router-link>
  </div>
</template>

<script>
export default {
  props: {},
  computed: {
    isDark: function () {
      return this.$route.path === "/scan" ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  a {
    padding: 16px 0 8px;
  }
  img {
    height: 18px;
    width: auto;
  }
}
.invert {
  filter: brightness(0) invert(1);
}
</style>
